/**
 * Base URL for the nuadvisory .NET API (advisory-api.*.nu-assist.com).
 * All cross-origin fetches include `credentials: "include"` so the
 * `nu_assist_session` cookie rides the request (NuAssistOrCookie policy).
 *
 * Must stay on the `*.nu-assist.com` parent domain so the session cookie
 * is in scope for the cross-origin request.
 */
export const NUADVISORY_BASE =
  import.meta.env.VITE_NUADVISORY_API_URL ?? "https://advisory-api.dev.nu-assist.com";
